class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(`${rootUrl}search/suggest?q=${searchTerm}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
        
        // Attendre que le DOM soit mis à jour
        setTimeout(() => {
          if (typeof window.initQuickAdd === 'function') {
            window.initQuickAdd();
            
            // Vérifier que les boutons sont bien présents et attachés
            const buttons = this.predictiveSearchResults.querySelectorAll('[data-variant-add]');
            
            // Vérifier que les événements sont bien attachés
            buttons.forEach(button => {
              if (!button.onclick) {
                button.addEventListener('click', window.handleQuickAdd);
              }
            });
          }
        }, 100);
      })
      .catch((error) => {
        console.error('Erreur de recherche:', error);
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
